/* eslint-disable react/function-component-definition */
import React, { Component } from 'react';
import axios from 'axios';
import './AutocompleteDMTI.scss';
import { TextInput } from '../../../../canvasComponents/index';
import { FormattedMessage, IntlProvider } from 'react-intl';
import { AddressModal } from '../AddressModal/AddressModal';
import { addressValidation } from '../../../../services/addressService';
import FormioErrorHandler, { useErrorStatus } from '../../../../components/FormioErrorHandler/FormioErrorPopup';
import { ENTERPRISE_OR_VENDOR_LOCATOR_FAILED } from '../../../../containers/Error/ErrorTypes';

const withHooksHOC = (ChildComponent) => (props) => {
  const { setError } = useErrorStatus();
  return <ChildComponent setError={setError} {...props} />;
};
class CustAutocompleteDMTI extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showModal: false,
      error: { found: false, message: '' },
      // The suggestions that match the user's input
      filteredSuggestions: [],
      // What the user has entered
      value: props.value,
    };
    this.bearerToken = {
      token: null,
      expiresOn: null,
    };
    this.label = props.label;
    this.id = props.id;
    this.setShowModal = this.setShowModal.bind(this);
    this.setSubmitAddress = this.setSubmitAddress.bind(this);
    this.setError = props.setError;
  }

  componentDidMount() {
    this.getDmtiToken();
  }

  componentDidUpdate() {
    const {
      state: { error },
      props: { showErrorHandling },
    } = this;

    if (error.found && error.message === 'error validating' && !showErrorHandling) {
      this.setError({
        type: ENTERPRISE_OR_VENDOR_LOCATOR_FAILED,
      });
    }
  }

  setShowModal = () => {
    this.setState((prevState) => ({
      showModal: !prevState.showModal,
    }));
  };

  setSubmitAddress = (address) => {
    const { props: { handleChange, index } } = this;
    let finalAddress = {};
    let concatenatedAddress = '';

    if (address.country === 'CA') {
      finalAddress = {
        street: address.street,
        streetName: address.streetName,
        city: address.city,
        country: address.country,
        provinceState: address.province,
        postalCode: address.postalCode,
      };

      concatenatedAddress = `${address.street} ${address.streetName} ${address.city} ${address.province} ${address.country} ${address.postalCode}`;
    } else {
      finalAddress = {
        street: address.street,
        streetName: address.streetName,
        city: address.city,
        country: address.country,
        provinceState: address.state,
        postalCode: address.zipCode,
      };
      concatenatedAddress = `${address.street} ${address.streetName} ${address.city} ${address.state} ${address.country} ${address.zipCode}`;
    }

    this.setState(
      (prevState) => (
        {
          showModal: !prevState.showModal,
          error: { found: false, message: '' },
          value: {
            value: concatenatedAddress,
            addressObj: finalAddress,
          },
        }),
      () => {
        // eslint-disable-next-line react/destructuring-assignment
        handleChange(this.state.value, index, 'address');
      },
    );
  };

  getDmtiToken = () => {
    axios
      .get('/dmti/token')
      .then((res) => {
        if (res.status === 200 && res.data.access_token) {
          const d = new Date();
          this.bearerToken.expiresOn = new Date(d.getTime() + res.data.expires_in * 1000);
          this.bearerToken.token = res.data.access_token;
        }
      }).catch((err) => {
        console.log(err);
      });
  };

  onChange = (currentValue) => {
    const { state: { value }, props: { handleChange, index } } = this;
    const { customOnChange } = this.props || null;

    this.setState(
      {
        value: { value: currentValue, addressObj: value?.addressObj },
      },
      () => {
        if (customOnChange) {
          customOnChange(currentValue);
        }
      },
    );

    if (!this.bearerToken.expiresOn || this.bearerToken.expiresOn.getTime() - (new Date()).getTime() < 10000) {
      this.getDmtiToken();
    }

    if (currentValue.length > 5 && (currentValue.length % 3) === 0) {
      axios
        .get(`/dmti/suggestions/${this.bearerToken.token}/${currentValue}`)
        .then((res) => {
          if (res.data.length > 0) {
            const filteredSuggestions = res.data.map(
              (result) => result.aliasSuggest,
            );

            this.setState(
              {
                filteredSuggestions,
                error: { found: false, message: '' },
              },
            );
          } else {
            this.setState(
              {
                filteredSuggestions: [],
                error: { found: true, message: 'no suggestions' },
              },
              () => {
                handleChange({
                  value: '',
                  addressObj: {},
                }, index, 'address');
              },
            );
          }
        }).catch((error) => {
          if (error.code === 'ERR_NETWORK') {
            this.setError({
              type: 'CONNECTION_ERROR',
            });
          }
          this.setState(
            {
              filteredSuggestions: [],
              error: { found: true, message: 'error validating' },
            },
            () => {
              handleChange({
                value: '',
                addressObj: {},
              }, index, 'address');
            },
          );
        });
    }
  };

  onClick = async (selectedAddress) => {
    const { props: { handleChange, index, getCoordinates } } = this;
    try {
      const address = await addressValidation(selectedAddress);
      let addressObj = {};
      if (address?.addressValidation && address?.addressValidation.addressValidationResult === 'true') {
        addressObj = {
          street: address.addressValidation.streetNumber,
          streetName: `${address.addressValidation.streetName ? address.addressValidation.streetName : ''}${address.addressValidation.streetType ? ` ${address.addressValidation.streetType}` : ''}${address.addressValidation.streetDirection ? ` ${address.addressValidation.streetDirection}` : ''}`,
          city: address.addressValidation.municipality,
          country: 'Canada',
          provinceState: address.addressValidation.province,
          postalCode: address.addressValidation.postalCode,
        };
        if (getCoordinates) {
          addressObj.latitude = address.addressValidation.latitude;
          addressObj.longitude = address.addressValidation.longitude;
        }

        this.setState(
          {
            filteredSuggestions: [],
            error: { found: false, message: '' },
            value: {
              value: selectedAddress,
              addressObj,
            },
          },
          () => {
            // eslint-disable-next-line react/destructuring-assignment
            handleChange(this.state.value, index, 'address');
          },
        );
      } else {
        this.setState(
          {
            filteredSuggestions: [],
            error: { found: true, message: 'error validating' },
          },
          () => {
            handleChange({
              value: '',
              addressObj: {},
            }, index, 'address');
          },
        );
      }
    } catch (error) {
      this.setState(
        {
          filteredSuggestions: [],
          error: { found: true, message: 'error validating' },
        },
        () => {
          handleChange({
            value: '',
            addressObj: {},
          }, index, 'address');
        },
      );
    }
  };

  render() {
    const {
      onChange,
      onClick,
      state: { filteredSuggestions, value, error, showModal },
      props: { placeholder, disabled, localParams, showErrorHandling },
      label,
      id,
    } = this;

    let suggestionsListComponent;
    let errorHandlingComponent;

    if (value && value.value && value.value.length > 5 && filteredSuggestions.length) {
      suggestionsListComponent = filteredSuggestions.map((suggestion) => ({
        value: suggestion,
        label: <span>{suggestion}</span>,
      }));
    } else if (value && value.value && value.value.length > 5) {
      errorHandlingComponent = (
        error.found && (error.message === 'error validating' || error.message === 'no suggestions') ? <p className="address-error-message"><FormattedMessage id="Uh oh! Looks like we're having trouble validating this address. Please" defaultMessage="Uh oh! Looks like we're having trouble validating this address. Please" /> <button type="button" onClick={this.setShowModal} className="addAddressBtnDMTI"> <FormattedMessage id="add address" defaultMessage="add address" /></button> <FormattedMessage id="manually to continue." defaultMessage="manually to continue." /></p> : null
      );
    }

    return (
      <IntlProvider locale={localParams?.lang} messages={localParams?.i18n}>
        <div style={{ position: 'relative' }} className="fs-exclude">
          {label && <label htmlFor={id} style={{ marginBottom: '8px' }}>{label}</label>}
          <TextInput
            searchable
            searchResults={suggestionsListComponent}
            minLengthForSearchResults={6}
            disabled={disabled}
            placeholder={placeholder}
            highlight
            primary
            onSelect={(selectedAddress) => onClick(selectedAddress)}
            onChange={(currentValue) => onChange(currentValue)}
            defaultValue={value?.value ? value.value : ''}
          />
          {showErrorHandling && errorHandlingComponent}
          <AddressModal
            type="DMTI"
            localParams={localParams}
            showModal={showModal}
            setShowModal={this.setShowModal}
            setSubmitAddressModal={this.setSubmitAddress}
          />
        </div>
      </IntlProvider>
    );
  }
}

const CustomAutocompleteDMTIWithHooks = withHooksHOC(CustAutocompleteDMTI);

export default function CustomAutocompleteDMTI(props) {
  return <FormioErrorHandler><CustomAutocompleteDMTIWithHooks {...props} /></FormioErrorHandler>;
}
